/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect } from 'react';

import CloudpassService from '../../services/cloudpassService';

import { useLocalStateReducer } from '../../reducers';
import config from '../../client/config';
import AffiliatesService from '../../services/affiliatesService';

const cloudpassService = new CloudpassService(config.clientShortName);
const affiliatesService = new AffiliatesService();

const initialState = {
  country: null,
  loading: false,
  mso: []
};

export const useMsoConfigFetch = (props) => {
  const { isOpen } = props;
  const [state, setState, resetState] = useLocalStateReducer(initialState);

  const successCallback = useCallback((response) => {
    setState({ mso: response });
  });

  useEffect(() => {
    if (isOpen) {
      setState({ loading: true });
      cloudpassService.obtainMsoConfig()
        .then(successCallback)
        .then(() => setState({ loading: false }));
    }
  }, []);

  return {
    state,
    setState,
    resetState
  };
};

export const useCloudPassRedirectionHandler = (props, state) => {
  const { parameters } = props;
  const { configOptions } = window;

  const action = useCallback((idp) => {

    const baseUrl = new URL(parameters.failureRedirect);
    let baseLoginUrl = idp.loginUrl || configOptions.IDP_LOGINHTML_URL;

    if (baseUrl.origin.includes('callback')) {
      baseLoginUrl = idp.loginUrl || configOptions.IDP_LOGINHTML_URL_MOBILE;
    }

    const returnUrl = encodeURIComponent(parameters.failureRedirect);


    const loginUrl = baseLoginUrl
      .replace('{CP}', parameters.client_id)
      .replace('{IDP}', idp.shortName)
      .replace('{COUNTRY_CODE}', state.country)
      .replace('{RETURN_URL}', returnUrl)
      ;

    window.location = loginUrl;
  }, [props.parameters, state]);

  return action;
};

export const useCloudPassRedirectionHandlerAffiliates = (props, state) => {
  const { parameters } = props;
  const { country } = state;
  return useCallback((idp) => {
    const { shortName, loginUrl } = idp;
    const { returnUrl, failureRedirect, client_id } = parameters;

    const TBX_AFF_INVERTED_BINDING_INITIATE_URL = affiliatesService.getInvertedBindingInitializationURL(config.projectId, client_id, shortName, returnUrl, failureRedirect );
    const IDP_LOGINHTML_URL = cloudpassService.getLoginURL({countryCode: country, idpShortName: shortName})

    let baseLoginUrl = loginUrl || IDP_LOGINHTML_URL;

    const finalReturnUrl = encodeURIComponent(TBX_AFF_INVERTED_BINDING_INITIATE_URL);
    baseLoginUrl+= `&return=${finalReturnUrl}`;

    window.location = baseLoginUrl;

  }, [props.parameters, state]);
};
export const useCloudPassAuthorizeRedirectionHandler = (props, state) => {
  const { parameters } = props;
  const { configOptions } = window;

  const action = useCallback((idp) => {
    const baseUrl = new URL(parameters.redirect_uri);
    let baseLoginUrl = idp.loginUrl || configOptions.IDP_LOGINHTML_URL;

    if (baseUrl.origin.includes('callback')) {
      baseLoginUrl = idp.loginUrl || configOptions.IDP_LOGINHTML_URL_MOBILE;
    }
    const returnUrl = encodeURIComponent(parameters.redirect_uri);
    const loginUrl = baseLoginUrl
      .replace('{CP}', parameters.client_id)
      .replace('{IDP}', idp.shortName)
      .replace('{COUNTRY_CODE}', state.country)
      .replace('{RETURN_URL}', returnUrl);

    window.location = loginUrl;
  }, [props.parameters, state]);

  return action;
};
